module.exports = __webpack_public_path__ + "static/media/_DSC6194.715f8d67.jpg";